export default __webpack_public_path__ + "static/media/demonslave.07df2fef.png";